import React from 'react';

import Guidance from '../common/Guidance';
import { WATCH_HOW_VIDEOS } from '../../config/watchHowVideos';

/**
 * The personal collection may be shared, but a collection made for the
 * people and records in mind is the sounder choice: said once, before the
 * first grant, and never as a refusal. SharingTab decides when; this holds
 * the words and the Watch how wiring (KPR-1929).
 */
export default function PersonalSharingNudge() {
	return (
		<Guidance
			title="This is your personal collection"
			why="Sharing works, but a collection built for the people and the records you have in mind is easier to keep tidy."
			links={['collections/create-a-collection', 'sharing-and-export/share-with-a-person', 'collections/your-personal-collection']}
			action={{ label: 'Create a collection', to: '/collections/new' }}
			tone="suggest"
			dismissKey="personal-sharing"
			video={WATCH_HOW_VIDEOS.personalCollection}
		/>
	);
}
